import { createFileRoute } from "@tanstack/react-router";
import ReceiptsPage from "@/pages/ReceiptsPage";
import { ModuleGuard } from "@/components/auth/ModuleGuard";

export const Route = createFileRoute("/_app/receipts")({
  component: ReceiptsRoute,
});

function ReceiptsRoute() {
  return (
    <ModuleGuard module="receipts">
      <ReceiptsPage />
    </ModuleGuard>
  );
}
